import { cn } from "@bem-react/classname";
import { IjQ } from "pages/TeacherTest/TeacherTest";
import { FC } from "react";
import { useConstructor } from "utils";
import "./Help.scss"


  declare global {
    interface Window {
      jQuery: IjQ
    }
  }

const Help:FC<{name: string}> = ({name}) => {
    const cnHelp = cn('Help')
    useConstructor(() => {
        if (!window.hasOwnProperty('jQuery')){
            const jquery = document.createElement('script')
            jquery.src = '/js/jquery.min.js'
            document.head.appendChild(jquery)  
        }
        if (!window.jQuery.fn.hasOwnProperty('dialog')){
            const jqui = document.createElement('script')
            jqui.src = '/js/jquery-ui.js'
            document.head.appendChild(jqui)
            const jquicss = document.createElement('link')
            jquicss.rel  = 'stylesheet';
            jquicss.type = 'text/css';
            jquicss.href = '/js/jquery-ui.min.css';
            jquicss.media = 'all';
            document.head.appendChild(jquicss)
        }    
    });
    
    const click = ()=>{
        window.jQuery.post('/help?ajax=1&name=' + name, 
            function(resp: string){
                window.jQuery('<div class="left_margin"></div>').html(resp).dialog({'title':'Помощь', 'width':Math.min(500, window.innerWidth-15), dialogClass: 'jq-ui-dialog-max-width'})
        }, 'html');
        return false;
    }
    return <div className={cnHelp()} title="Помощь" onClick={click}>?</div>
}

export default Help